<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="filteredItems"
    sort-desc
    item-key="paymethod_id"
    show-select
    calculate-widths
    class="paymethod-dt"
    height="calc(100vh - 108px - 48px)"
    fixed-header
    :loading="loading"
    :footer-props="{'items-per-page-options': [25, 50, 100, -1]}"
    :items-per-page="50"
  >

    <template v-slot:top>
      <update-form v-model="dialog" :item="item" :types="types" :paysystems="paysystems" :refresh="load" />
      <copy-form v-model="dialogCopy" :items="map(selected, 'paymethod_id')" />
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>

        <v-btn
          color="info"
          v-on:click="load"
          class="mt-3"
          :disabled="loading"
          :loading="loading"
        >
          Search
        </v-btn>

        <v-spacer />

        <v-item-group
          class="v-btn-toggle v-btn-toggle--borderless"
        >
          <v-btn
            color="success"
            v-on:click="save()"
            class="mt-3"
            :disabled="keys(editItems).length == 0"
          >
            Save {{ keys(editItems).length ? ': ' + keys(editItems).length : '' }}
          </v-btn>

          <v-menu
            v-model="saveMenu"
            :close-on-content-click="false"
            offset-y
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                width="20"
                style="min-width: 0px;"
                class="mt-3 mr-5"
                color="success"
                fab
                v-on="on"
                :disabled="keys(editItems).length == 0"
              >
                <v-icon small>mdi-arrow-down</v-icon>
              </v-btn>
            </template>

            <v-btn
              min-width="110"
              small
              color="success"
              v-on:click="saveAs"
              :disabled="keys(editItems).length == 0"
            >
              Save As
            </v-btn>
          </v-menu>
        </v-item-group>


        <v-btn
          color="success"
          v-on:click="dialogCopy = true"
          class="mt-3 mr-5"
          :disabled="selected.length == 0 || keys(editItems).length > 0"
        >
          Copy {{ selected.length ? ': ' + selected.length : '' }}
        </v-btn>
      </v-row>
    </template>

    <template v-slot:body.prepend>
      <tr v-if="Object.keys(filters).length > 0" class="paymethod-dt-filter-row grey lighten-3">
        <td></td>
        <td
          v-for="header in headers"
          :key="header.text"
        >
          <v-autocomplete
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
            hide-details
            dense
            small
            multiple
            clearable
            persistent-hint
            single-line
            class="paymethod-filter-select mt-0"
            :items="filters[header.value].values || columnValueList(header.value)"
            :style="{width: (filters[header.value] || {width: false}).width}"
            v-model="filters[header.value].data"
          ></v-autocomplete>
          <v-text-field
            dense
            class="paymethod-filter-textfield mt-0"
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
            v-model="filters[header.value].data"
            :style="{width: (filters[header.value] || {width: false}).width}"
            hide-details
          ></v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:item.action="{ item }">
      <div style="width: 50px" class="float-right">
        <v-icon v-if="editItems[item.paymethod_id]" small @click="toggleEdit(item)">mdi-close</v-icon>
        <v-icon v-if="!editItems[item.paymethod_id]" small @click="toggleEdit(item)">edit</v-icon>
        <v-icon v-if="!editItems[item.paymethod_id]" small @click="edit(item)">mdi-cog-outline</v-icon>
      </div>
    </template>

    <template v-slot:item.row_num="{ item }">
      <span class="row_num"></span>
    </template>


    <template v-slot:header.action="{ item }">
      <div style="width: 50px" class="float-right">
        <v-icon @click="edit(newItem)">mdi-plus</v-icon>
      </div>
    </template>

    <template v-slot:item.paysystem="{ item }">
      <template v-if="editItems[item.paymethod_id]">
        <v-autocomplete
          class="paymethod-filter-textfield"
          v-model="editItems[item.paymethod_id].paysystem_id"
          :prefix="'#' + (editItems[item.paymethod_id].paysystem_id || '')"
          :items="paysystems"
          item-text="name"
          item-value="paysystem_id"
          auto-select-first
          dense
          hide-details
          :return-object="false"
        >
          <template v-slot:selection="{ item: i }">
            {{ i.name }} {{ i.comments ? `(${i.comments})` : '' }}
          </template>
          <template v-slot:item="{ item: i }">
            #{{ i.paysystem_id }} {{ i.name }} {{ i.comments ? `(${i.comments})` : '' }}
          </template>
        </v-autocomplete>
      </template>
      <template v-else>
        #{{ item.paysystem_id }} {{ item.paysystem }} {{ item.paysystem_desc ? `(${item.paysystem_desc})` : '' }}
      </template>
    </template>

    <template v-slot:item.name="{ item }">
      <template v-if="editItems[item.paymethod_id]">
        <v-text-field
          class="paymethod-filter-textfield"
          v-model="editItems[item.paymethod_id].name"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.name }}
      </template>
    </template>

    <template v-slot:item.type="{ item }">
      <template v-if="editItems[item.paymethod_id]">
        <v-combobox
          class="paymethod-filter-textfield"
          :items="types"
          v-model="editItems[item.paymethod_id].type"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.type }}
      </template>
    </template>

    <template v-slot:item.code="{ item }">
      <template v-if="editItems[item.paymethod_id]">
        <v-text-field
          class="paymethod-filter-textfield"
          v-model="editItems[item.paymethod_id].code"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.code }}
      </template>
    </template>

    <template v-slot:item.title="{ item }">
      <template v-if="editItems[item.paymethod_id]">
        <v-text-field
          class="paymethod-filter-textfield"
          v-model="editItems[item.paymethod_id].title"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.title }}
      </template>
    </template>

    <template v-slot:item.whitelist="{ item }">
      <span class="text-no-wrap" v-if="item.settings.whitelist">
        Dep. Count: <b>{{ item.settings.whitelist.deposit_count }}</b><br />
        Dep. Amount: <b>{{ item.settings.whitelist.deposit_sum }} EUR</b>
      </span>
    </template>
    <template v-slot:item.convert_to="{ item }">
      <template v-if="item.settings.convert_to">
        <template v-if="isString(item.settings.convert_to)">{{ item.settings.convert_to }}</template>
        <div v-if="isObject(item.settings.convert_to)" style="max-width: 160px">
          {{ currencyConvertObj2Arr(item.settings.convert_to).join(', ') }}
        </div>
        <template v-if="isArray(item.settings.convert_to)">{{ item.settings.convert_to.join(', ') }}</template>
      </template>
    </template>
  </v-data-table>
</template>

<style>

  .paymethod-dt-filter-row .paymethod-filter-textfield {
    padding-top: 6px;
  }

  .paymethod-dt .v-btn-toggle .v-btn {
    min-height: 36px !important;
    height: 36px !important;
  }

  .paymethod-dt-filter-row .v-input,
  .paymethod-dt .paymethod-filter-textfield {
    font-size: 0.875rem;
  }

  .paymethod-dt-filter-row td {
    height: 33px !important;
  }

  .paymethod-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .paymethod-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .paymethod-dt.v-data-table td,
  .paymethod-dt.v-data-table th {
    padding: 0 8px !important;
  }

  .paymethod-dt .v-data-footer__select .v-select {
    margin: 5px 0 10px 34px;
  }

  .paymethod-dt .v-data-footer {
    justify-content: center;
  }
</style>

<script>
  import { debounce, filter, get, isArray, toArray, isObject, isString, toString, sortBy, cloneDeep, map, clone, omit } from 'lodash'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    components: {
      SelectProject,
      UpdateForm: () => import('@/components/settings/paymethods/UpdateForm'),
      CopyForm: () => import('@/components/settings/paymethods/CopyForm'),
    },

    data: () => ({
      editItems: {},
      newItem: {
        settings: {}
      },
      saveMenu: false,
      dialog: false,
      dialogCopy: false,
      project: null,
      item: {},
      selected: [],
      paysystems: [],
      loading: false,
      filters: {
        paysystem: { data: [], type: 'select' },
        paymethod: { data: [], type: 'select' },
        name: { data: [], type: 'select' },
        type: { data: [], type: 'select' },
        code: { data: [], type: 'text' },
        title: { data: [], type: 'text' },
      },
      filtersD: {},
      headers: [
        // { text: '#', value: 'row_num', sortable: false },
        { text: 'ID', value: 'paymethod_id' },
        { text: 'Paysystem', value: 'paysystem' },
        { text: 'Alias', value: 'name' },
        { text: 'Code', value: 'code' },
        { text: 'Title', value: 'title' },
        { text: 'Type', value: 'type' },
        { text: 'Whitelist', value: 'whitelist', sortable: false },
        { text: 'Convert to', value: 'convert_to', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],
      items: []
    }),

    mounted () {
      this.load().then(r => this.loadPaysystems())
    },

    watch: {
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    computed: {
      types: function () {
        return this.columnValueList('type')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    methods: {
      map,
      isArray,
      isObject,
      isString,

      keys (obj) {
        if (!obj) return {}
        return Object.keys(obj)
      },

      columnValueList (val) {
        return sortBy(filter(this.items.map(d => get(d, val)), (i) => i))
      },

      currencyConvertObj2Arr (o) {
        let out = []
        for (let k in o) {
          out.push(k + ' -> ' + o[k])
        }

        return out
      },
      toggleEdit (item) {
        item.edit = !item.edit
        if (!item.edit) {
          delete this.editItems[item.paymethod_id.toString()]
        } else {
          this.editItems[item.paymethod_id] = item
        }

        this.editItems = cloneDeep(this.editItems)
      },
      edit (item) {
        this.dialog = true
        this.item = cloneDeep(item)
      },
      copy () {
        this.dialogCopy = true
      },

      loadPaysystems () {
        this.loading = true
        return API.call('/$v/paysystem/list.json', {}).then(resp => {
          this.paysystems = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
      load () {
        this.loading = true
        return API.call('/$v/paymethod/list.json', {}, null, this.project).then(resp => {
          this.editItems = {}
          this.selected = []
          this.items = resp.data || []
        }).finally(() => {
          this.loading = false
        })
      },

      async save (message = 'Save paymethods', saveAs = false) {
        let items = toArray(this.editItems)
        if (items.length == 0) return

        if (saveAs) {
          items = map(items, item => omit(item, 'paymethod_id'))
        }

        let buttons = [
          { text: 'Save', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        let confirmRes = await this.$root.$confirm('Confirm', message, { width: 515, buttons })

        if (!confirmRes) {
          return
        }

        this.loading = true
        return API.call('/$v/paymethod/update.json', { items: items }, null, { entity_id: items[0].entity_id }).then(resp => {

          this.$notification.show = true
          this.$notification.message = 'Paymethods updated'
          this.$notification.type = 'success'

          return this.load()
        }).finally(() => {
          this.loading = false
        })
      },

      async saveAs () {
        return this.save('Save paymethods as new', true)
      }
    },

  }
</script>

